<template>
  <div class="mt-2 box">
    <div class="px-0 box">
      <vue-editor
        ref="editor"
        :editor-toolbar="customToolbar"
        v-model="content"
        @text-change="onChange"
        @blur="onBlur"
      />
      <div v-show="canSave && !forReference" class="save-button px-3 pb-2 layout justify-end align-center">
        <v-btn @click="save" dark small depressed color="primary" class="button">Save</v-btn>
      </div>
      <!-- <ckeditor
        v-model="content"
        :config="editorConfig"
        :editor="editor"
        class="editor"
        @[trackKeydown]="$emit('done', content)"
        @blur="e => $emit('done', content)"
        @input="() => { if (forReference) { $emit('done', content) } else { this.canSave = true } }"
      />-->
    </div>
    <!-- <div class="d-flex mt-3" v-if="!forReference">
      <v-spacer></v-spacer>
      <v-btn :disabled="!canSave" @click="$emit('done', content)" color="primary" depressed>
        Save
      </v-btn>
    </div>-->
  </div>
</template>

<script>
// import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

// import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
// import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
// import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
// import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
// import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
// import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
// import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
// import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript";
// import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript";
// import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
// import Clipboard from "@ckeditor/ckeditor5-clipboard/src/clipboard";
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';

let initialValue = null;

export default {
  name: 'EditorComponent',
  components: {
    vueEditor: VueEditor
  },
  props: {
    html: {
      type: String
    },
    forReference: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.html) {
      initialValue = this.html;
      this.content = this.html;
      // this.$refs.editor.quill.focus();
    }
  },
  data() {
    return {
      content: null,
      // editor: ClassicEditor,
      canSave: false,
      customToolbar: [['bold', 'italic'], [{ script: 'sub' }, { script: 'super' }], [{ list: 'bullet' }]]
      // editorConfig: {
      //   plugins: [
      //     EssentialsPlugin,
      //     BoldPlugin,
      //     Clipboard,
      //     ItalicPlugin,
      //     LinkPlugin,
      //     ParagraphPlugin,
      //     ListPlugin,
      //     Subscript,
      //     Superscript,
      //     PasteFromOffice
      //   ],

      //   toolbar: {
      //     items: this.toolbarItems()
      //   }
      // }
    };
  },
  computed: {
    trackKeydown() {
      return this.forReference ? 'text-change' : null;
    }
  },
  watch: {
    html: function(e) {
      if (!e) e = '';
      this.content = e;
    }
  },
  methods: {
    onChange(newVal, oldVal) {
      // TODO: Not good couse newVal length is 1 couse mounted changes state initialy
      if (newVal.ops.length > 1) {
        this.canSave = true;
        if (this.forReference) {
          this.$emit('done', this.content);
        }
      }
    },
    save() {
      this.$emit('done', this.content);
      this.canSave = false;
    },
    onBlur() {
      if (this.content) {
        this.save();
      }
    },
    update: async function() {
      this.$emit('update', this.html);
    }
  }
};
</script>

<style scoped>
.save-button {
  justify-content: end;
  margin-top: -35px;
  z-index: 1000;
  position: relative;
}
.save-button .button {
}
</style>

<style>
@import '~vue2-editor/dist/vue2-editor.css';

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
.box {
  width: 100%;
}
.ck.ck-button.ck-on {
  font-weight: bold !important;
}
.ql-toolbar {
  background-color: #f5f5f5 !important;
  border-bottom: 0px !important;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  border: 0px !important;
}
.quillWrapper {
  border-radius: 3px !important;
}
.ql-container {
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  border: 0px !important;
}

.ql-editor {
  min-height: 200px;
  width: 100%;
  background-color: #f5f5f5 !important;
  border: 0px !important;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
.ck-content:focus {
  box-shadow: none !important;
}
.ck-toolbar {
  background-color: #f5f5f5 !important;
  border-bottom: 1px solid var(--light-form-bg) !important;
  border: 0px !important;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.ck-content li {
  list-style-type: circle !important;
}

.menuebar {
  outline: none;
}

.bar .v-btn {
  height: 100% !important;
}

.content * {
  outline: none;
}

.content {
}

.menuebar__button {
}
.editr {
  border-radius: 5px;
  background-color: #ecf3f6 !important;
  width: 100%;
}

.editr--toolbar {
  position: relative;
  display: flex;
  height: 32px;
  background-color: white !important;
  border-bottom: 1px solid var(--light-form-bg);
}

.editr--toolbar a {
  display: inline-block;
  width: 8vw;
  max-width: 32px;
  height: 32px;
  color: #333;
  fill: #333;
  cursor: pointer;
  text-align: center;
  line-height: 1;
}

.editr--toolbar a:hover {
  background: rgba(0, 0, 0, 0.1);
}

.editr--toolbar a:active {
  background: rgba(0, 0, 0, 0.2);
}

.editr--toolbar a svg {
  width: 16px;
  height: 16px;
  margin: 8px auto;
}

.editr--toolbar a svg path {
  fill: inherit;
}

.editr--toolbar a.vw-btn-separator {
  width: 1px;
  margin: 0 8px;
}

.editr--toolbar a.vw-btn-separator:hover {
  background: initial;
  cursor: default;
}

.editr--toolbar a.vw-btn-separator i.vw-separator {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  height: 100%;
  position: absolute;
  width: 1px;
}

.editr--toolbar .dashboard {
  width: 100%;
  position: absolute;
  top: 32px;
  left: 0;
  text-align: left;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #f6f6f6;
}

.editr--content {
  min-height: 150px;
  padding: 12px 8px 16px 8px;
  line-height: 1.33;
  font-family: inherit;
  color: inherit;
  overflow-y: auto;
}

.editr--content[contenteditable='true']:empty:before {
  content: attr(placeholder);
  color: rgba(0, 0, 0, 0.3);
  display: block; /* For Firefox */
}

.editr--content img {
  max-width: 100%;
}

.editr--content table {
  width: 100%;
  border-collapse: collapse;
}

.editr--content table th {
  text-align: left;
}

.editr--content table th,
.editr--content table td {
  border: 1px solid #ddd;
  padding: 2px;
}

.editr--content:focus {
  outline: 0;
}

.editr--content ul li,
.editr--content ol li {
  list-style-position: inside;
  list-style-type: square;
}

@media screen and (max-width: 320px) {
  .editr--toolbar a {
    margin: 0 2px;
  }

  .editr--toolbar a.vw-btn-separator {
    display: none;
  }
}

/*
   * The MIT License
   * Copyright (c) 2012 Matias Meno <m@tias.me>
   */
@-webkit-keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }
  30%,
  70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px);
  }
}

@-moz-keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }
  30%,
  70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px);
  }
}

@keyframes passing-through {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }
  30%,
  70% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    -webkit-transform: translateY(-40px);
    -moz-transform: translateY(-40px);
    -ms-transform: translateY(-40px);
    -o-transform: translateY(-40px);
    transform: translateY(-40px);
  }
}

@-webkit-keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }
  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@-moz-keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }
  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    -moz-transform: translateY(40px);
    -ms-transform: translateY(40px);
    -o-transform: translateY(40px);
    transform: translateY(40px);
  }
  30% {
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1);
  }
  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

@-moz-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1);
  }
  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  10% {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1);
  }
  20% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

.form[data-v-ebce4d12] {
  display: flex;
  align-content: flex-end;
}

.form label[data-v-ebce4d12] {
  margin-right: 1rem;
}
</style>
